<div class="edit-job-status-wrapper">
    <h4 class="job-detail-title">{{ 'TC.Common.Status' | translate }}</h4>
    <div class="status-field">
        <gsp-dropdown
            id="edit-job-status"
            [options]="options"
            [(ngModel)]="selectedDisplayName"
            (ngModelChange)="onStatusChange($event)"
        ></gsp-dropdown>
    </div>
</div>
